import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  validateWrapper: ({ spacing }) => css`
    max-width: calc(100% - ${spacing.md});
    margin: ${spacing.lg} auto;
  `,

  mainWrapper: ({ spacing }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing.md};
    align-items: center;
    text-align: center;
    vertical-align: center;
    justify-content: center;
  `,
})

export { useStyles }
